<template>
  <div>
    <div>
      <my-brand :routerlist="routerlist" />
    </div>
    <div class="tokenDetail" data-aos="fade-up" data-aos-duration="1500">
      <div class="introduce-content">
        <h2 class="tokenDetail-title">
          {{ projectData.project_name }} By {{ projectData.project_artist }}
        </h2>
        <div class="about">
          {{ projectData.project_description }}
        </div>
        <!-- <div class="con-item">
        <p class="single-item">
          Cloud Blobs
          <span class="value">6</span>
        </p>
      </div> -->
        <div class="btn-warp">
          <button
            class="btn-item hvr-shutter-out-vertical mb-4"
            @click="toProject(projectData.project_id)"
          >
            {{ projectData.project_name }} Gallery
          </button>

          <a
            class="btn-item hvr-shutter-out-vertical"
            :href="`${$config.normalRequestBaseUrl}/art/${id}/html`"
            target="_blank"
          >
            Live Script
          </a>
        </div>
      </div>
      <div class="pictureDisplay">
        <picFrame
          class="pic-frame"
          :img-src="`${$config.normalRequestBaseUrl}/art/${id}/png`"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import mockData from '@/config/mock.js';
import * as http from "@/common/utils/request.js";
export default {
  data() {
    return {
      id: this.$route.params.tokenID,
      projectData: [],
    };
  },
  components: {
    picFrame: () => import("@/components/basic/frame.vue"),
  },
  methods: {
    // token详情
    async getTokenData() {
      const params = {
        tokenId: this.id,
      };
      try {
        const res = await http.fetchGet("/api/tokenInfo", params);
        console.log({ res });
        this.projectData = res.data?.data?.ProjectInfo;
      } catch (error) {
        console.log(error);
      }
    },

    toProject(id) {
      this.$router.push(`/projectDetail/${id}/gallery`);
    },
  },
  created() {
    this.getTokenData();
  },
  computed: {
    routerlist() {
      return [
        { to: "/", name: "Home" },
        { to: "/projects", name: "Projects" },
        { to: `/projectDetail/${this.projectData.project_id}`, name: "ProjectDetail" },
        { to: `/projectDetail/${this.projectData.project_id}/gallery`, name: "Gallery" },
        { name: "Token" },
      ];
    },
  },
};
</script>

<style lang="less" scoped>
.con-item {
  margin-top: 30px;
  .single-item {
    display: flex;
    padding: 16px 0 8px 0px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    .value {
      flex: 1;
      text-align: right;
      color: rgba(158, 62, 62, 0.6);
    }
    .site {
      color: rgb(134, 181, 219);
    }
  }
}
.about {
  margin: 16px 0;
  color: rgba(255, 255, 255, 0.4);
}
.btn-warp {
  width: 100%;
  margin-top: 40px;
  .btn-item {
    display: inline-block;
    width: 100%;
    padding: 12px 0px;
    color: #fff;
    background-color: #3b4d55;
    font-weight: 600;
    font-size: 18px;
    border-radius: 2px;
    outline: none;
    text-align: center;
    &:hover {
      border: none;
    }
  }
}

@media (max-width: 1025px) {
  .tokenDetail {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    flex-wrap: wrap;
    padding: 40px 0;
    .introduce-content {
      width: 90%;
      padding: 0px 20px;
      text-align: center;
      .tokenDetail-title {
        font-size: 16px;
      }
    }
    .pictureDisplay {
      width: 80%;
      text-align: right;
      margin-bottom: 30px;
      .frame {
        width: 100%;
      }
    }
  }
}

@media (min-width: 1026px) {
  .tokenDetail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 40px 0;
    .introduce-content {
      width: 45%;
      padding: 0px 20px;
      .tokenDetail-title {
        font-size: 20px;
      }
    }
    .pictureDisplay {
      width: 45%;
      text-align: right;
      .frame {
        width: 90%;
      }
    }
  }
}
</style>